import { DatenauswertungJahrauswahl } from '../../../bereiche/datenauswertung/DatenauswertungJahrauswahl';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { formStyle } from '../../../core/forms/WFormFramework';
import { IDs } from '../../../helpers/IDs';
import * as React from 'react';
import { VerbandslistePdf } from './VerbandslistePdf';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface VerbandslisteProps extends React.ClassAttributes<any> {
    data: any;
}

export interface VerbandslisteState {
    jahrFirst: number;
    jahrLast: number;
    renderPdfButton: JSX.Element;
    row: any;
    showExport: boolean;
}

export class Verbandsliste extends React.Component<VerbandslisteProps, VerbandslisteState> {

    constructor(props: any) {
        super(props);
        this.state = {
            jahrFirst: this.jahrMin,
            jahrLast: this.jahrMax,
            renderPdfButton: null,
            row: null,
            showExport: false
        };
    }

    private jahrMax: number = new Date().getFullYear();
    private jahrMin: number = 2020;

    getValues(): Array<any> {
        return ((this.props.data || {})[IDs.ENT_VERBAND_ZUORDNUNG] || [])
            .filter((item: any) => item.verband_orig === (this.state.row || {}).tid)
            .map((item: any) => ([item.registrierung || null, ...Array.from(Array(9).keys()).map(() => '...')]));
    }

    getCustomActions(): Array<any> {
        return [
            {
                id: 'show',
                label: 'Export Jahresübersicht',
                key: 'export',
                func: (row: any) => this.setState({ row, showExport: true }),
                info: 'Export Jahresübersicht'
            }
        ];
    }

    render(): JSX.Element {
        return (
            <>
                <WFormsTableWrapper
                    entity={IDs.ENT_VERBAND}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    formLayout='flowV2'
                    customClass='Custom-ETA'
                    customActions={this.getCustomActions()}
                    showColumnsHelp={true}
                />
                {this.state.showExport && this.renderExport()}
            </>
        );
    }

    renderAuswahlJahre(): JSX.Element {
        return (
            <DatenauswertungJahrauswahl
                jahrMin={this.jahrMin}
                jahrMax={this.jahrMax}
                jahrFirst={this.state.jahrFirst}
                jahrLast={this.state.jahrLast}
                contextKey='verbandsliste'
                externalHeaderElements={[this.state.renderPdfButton]}
                onFirstJahrChange={(jahr: number) => this.setState({ jahrFirst: jahr })}
                onLastJahrChange={(jahr: number) => this.setState({ jahrLast: jahr })}
            />
        );
    }

    renderExport(): JSX.Element {
        return (
            <DialogWrapper2
                title={`Jahresübersicht: ${(this.state.row || {}).name || null}`}
                onAfterClose={() => this.setState({ showExport: false })}
            >
                <div
                    className={formStyle.flowV2}
                    style={{
                        display: 'flex', flex: 1, flexDirection: 'column', marginTop: 16, marginLeft: 16, boxSizing: 'border-box',
                        overflow: 'hidden'
                    }}
                >
                    <div>
                        {this.renderAuswahlJahre()}
                    </div>
                    <div style={{ maxWidth: 0, maxHeight: 0, visibility: 'hidden' }}>
                        <VerbandslistePdf
                            jahrFirst={this.state.jahrFirst}
                            jahrLast={this.state.jahrLast}
                            setRenderButton={(renderButton: JSX.Element) => this.setState({ renderPdfButton: renderButton })}
                            values={this.getValues()}
                            verband={this.state.row}
                        />
                    </div>
                </div>
            </DialogWrapper2>
        );
    }
}
